export class BlujayCredentials {

  public username: string;
  public apiToken: string;

  static fromDto(d: any): BlujayCredentials {
    if (!d) {
      return null;
    }

    const blujayCredentials = new BlujayCredentials();

    blujayCredentials.username = d.username;
    blujayCredentials.apiToken = d.apiToken;

    return blujayCredentials;
  }

  isEmpty(): boolean {
    return !this.username && !this.apiToken;
  }
}
